<template>
  <div class="wrap" id="wrap">
    <div class="body" :class="bodyClassBinding()" :style="{ backgroundColor: isAnnouncement ? '#EEEEEE' : '' }">
      <spinner />
      <router-view v-slot="{ Component }">
        <!-- 260521: /gate(카카오 공유 랜딩)는 즉시 스토어로 보내는 standalone 페이지 -->
        <!-- 헤더·네비·햄버거가 같이 mount되면 푸터가 화면에 잠깐 걸쳐 보이는 버그 발생 → /gate 한정 layout 숨김 -->
        <template v-if="!isGatePage && !isQrPage">
          <header-bar />
          <SearchHeader />
        </template>
        <!-- 상단 헤더바 -->
        <transition name="fade">
          <keep-alive :include="keepAlive">
            <component :is="Component" />
          </keep-alive>
        </transition>

        <!--          <TheFooter />-->
        <template v-if="!isGatePage && !isSignInPage && !isQrPage">
          <floating-menu />
          <hamburger-menu />
          <!-- 하단 네비게이션바 -->
          <nav-bar />
        </template>
      </router-view>
      <audio
        :src="audio ? require(`@/assets/static/bgm/${audio}`) : require(`@/assets/static/bgm/mute.mp3`)"
        loop
        :muted="muted"
        ref="audioPlayer"
        autoplay
      />
    </div>
    <!-- 전체화면 modal component -->

    <teleport to="#wrap" v-for="(item, index) in modalComponents" :key="index">
      <component
        :index="index"
        :is="item.component"
        v-bind="item"
        @close="fnCloseModal(index)"
        @click="modalOutSideEvent($event, index)"
      />
    </teleport>
  </div>
</template>

<script setup>
import HeaderBar from '@/components/common/layouts/TheHeader.vue';
import SearchHeader from '@/components/common/layouts/SearchHeader.vue';
import NavBar from '@/components/common/layouts/TheNav.vue';
import { computed, onMounted, ref } from 'vue';
import Spinner from '@/components/common/layouts/Spinner.vue';
import { useStore } from 'vuex';
import { isEmpty } from '@/common/utils/Util';
import FloatingMenu from '@/views/main/FloatingMenu.vue';
import HamburgerMenu from '@/views/main/HamburgerMenu.vue';
import { useRoute } from 'vue-router';

const store = useStore();

const route = useRoute();
const isGatePage = computed(() => route.path === '/gate');
// 260707 온라인 현판 /s/* — 비로그인 스캔 랜딩. /gate와 동일하게 앱 셸(헤더·네비·플로팅) 숨김.
const isQrPage = computed(() => route.path.startsWith('/s/') || route.path.startsWith('/p/'));
// 260521: signIn 페이지 진입 시 FloatingMenu/HamburgerMenu(fixed position, DOM 상주)가
//   잔재로 상단에 노출되거나 nav routeLayout state 동기화 race로 푸터가 잘못된 위치에
//   걸쳐 보이던 사례 방지. 헤더는 유지(뒤로가기·제목 필요), nav/floating/hamburger만 hide.
// 260521 보강: 카카오 in-app 브라우저에서 trailing slash·대소문자 case 미스매치로 가드 fail
//   사례 발견 → toLowerCase + 끝 슬래시 제거 후 비교.
const isSignInPage = computed(() => {
  const p = (route.path || '').toLowerCase().replace(/\/+$/, '');
  return p === '/signin';
});

const isAnnouncement = computed(() => store.getters['layout/getIsAnnouncement']);
const keepAlive = computed(() => store.getters['layout/getKeepAlive']);
const modalComponents = computed(() => store.getters['layout/getModalComponents']);
const firstLogin = computed(() => store.getters['user/getFirstLogin']);

const audioPlayer = ref(null);
const audio = computed(() => store.getters['common/getAudio']);
const muted = computed(() => store.getters['common/getMuted']);

onMounted(() => {
  if (audioPlayer.value) {
    console.log('audioPlayer {}', audioPlayer.value);
    // audio 태그 저장 => audioPlayer 컴포넌트에서 VisibilityChange 이벤트에서 사용
    store.commit('common/setAudioPlayer', audioPlayer);
  }
});
const bodyClassBinding = () => {
  const route = useRoute();
  if (route.path.includes('/smile/invitation/info/')) {
    return 'max-width-500';
  }
  return '';
};

const modalOutSideEvent = (event, index) => {
  if (isEmpty(modalComponents.value)) return;
  console.log('모달 :', modalComponents.value);
  if (modalComponents.value[0].component.__name === 'EmoticonSelect') {
    return false;
  }
  const currentModal =
    store.getters['layout/getModalComponent'](index) || store.getters['layout/getModalComponent'](index - 1);
  console.log(currentModal);

  if (
    currentModal.component.__name === 'Auth' ||
    currentModal.component.__name === 'TutorialView' ||
    currentModal.component.__name === 'NaverSearch' ||
    currentModal.component.__name === 'KakaoPostModal' ||
    currentModal.component.__name === 'BusinessSearchModal' ||
    currentModal.component.__name === 'BusinessAddressDetail' ||
    currentModal.component.__name === 'Update'
  ) {
    return;
  }
  const targetElement = event.target;
  const layoutElement = document.querySelector('.modal');

  if (!layoutElement) return;
  if (!layoutElement.contains(targetElement)) {
    if (firstLogin) store.commit('user/setFirstLogin', false);
    if (currentModal.component.__name === 'MenuModal') {
      store.commit('layout/setIsNav', true);
    }
    fnCloseModal(index);
  }
};

const fnCloseModal = (index = 0) => {
  store.dispatch('layout/closeModalComponent', { index });
};
</script>

<style lang="scss">
.fade-enter-active {
  opacity: 0;
}
.fade-enter-to {
  opacity: 1;
  transition: opacity 0.3s;
}
</style>
